export enum UserRole {
  ArpaUnlimited = 'ArpaUserUnlimited',
  ArpaCanSeeTrace = 'ArpaUserCanSeeTrace',
  ArpaPowersIT = 'ArpaUserWithPowersIT',
  ArpaPowersLifePrebal = 'ArpaUserWithPowersLifePrebal',
  ArpaPowersLifeSantaLucia = 'ArpaUserWithPowersLifeSantaLucia'
}
